/**
 * Gemeinsamer TanStack-Query-Client (Gesamtprüfung 11.09.2026: als eigenes
 * Modul, damit er beim Abmelden geleert werden kann — sonst sah die nächste
 * Person am selben Gerät kurz die zwischengespeicherten Daten der vorigen).
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
